export interface IAdminClubInvitationRequest {
  club: number;
  emails: string[];
}

export interface IAdminEventInvitationRequest {
  club: number;
  emails: string[];
  event: number;
  isGuest: boolean;
}

export interface IAdminInvitation {
  accepted: boolean;
  club: {
    id: number;
  };
  email: string;
  event: number;
  expired: boolean;
  id: number;
  isGuest: boolean;
  match: boolean;
  sent: string;
}

export interface IAdminInvitationsStore {
  clubMemberships: {
    [clubId: string]: IAdminInvitation[];
  };
  eventMemberships: {
    [eventId: string]: IAdminInvitation[];
  };
}

export const adminInvitationsStore: IAdminInvitationsStore = {
  clubMemberships: {},
  eventMemberships: {}
};
